// // src/pages/CoursesToPromote.jsx
// import React, { useEffect, useMemo, useState } from "react";
// import { db } from "../firebase";
// import {
//   collection,
//   query,
//   where,
//   getDocs,
//   doc,
//   getDoc,
//   limit as qLimit,
// } from "firebase/firestore";
// import { getAuth } from "firebase/auth";

// /* ----------------------------- Helpers ----------------------------- */

// // Extract Google Drive file id
// function extractDriveId(rawUrl) {
//   const url = (rawUrl || "").trim();
//   if (!url) return null;
//   try {
//     const u = new URL(url);
//     if (!u.hostname.includes("drive.google.com")) return null;
//     const m = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
//     if (m && m[1]) return m[1];
//     const q = u.searchParams.get("id");
//     if (q) return q;
//   } catch (_) {}
//   return null;
// }

// // Robust Drive candidates (we try each in order)
// function buildDriveImageCandidates(thumbnailUrl) {
//   const id = extractDriveId(thumbnailUrl);
//   if (!id) return [];
//   return [
//     `https://drive.usercontent.google.com/uc?id=${id}&export=view`,
//     `https://drive.google.com/uc?export=view&id=${id}`,
//     `https://drive.google.com/uc?export=download&id=${id}`,
//     `https://lh3.googleusercontent.com/d/${id}=w1600-h900-no`,
//     `https://drive.google.com/thumbnail?id=${id}&sz=w1600`,
//   ];
// }

// // Build cover candidates for a course/product (Drive only → placeholder)
// function buildCoverCandidates(item = {}) {
//   const chain = [];
//   if (item?.thumbnailUrl)
//     chain.push(...buildDriveImageCandidates(item.thumbnailUrl));
//   chain.push("/placeholder.png");
//   return chain;
// }

// /* --------- Non-blinking, multi-source image with skeleton ---------- */
// // function ImageChain({
// //   sources = ["/placeholder.png"],
// //   alt = "",
// //   className = "",
// //   fit = "cover",
// //   aspect = "aspect-square",
// //   placeholder = "/placeholder.png",
// //   rounded = "rounded-xl",
// // }) {
// //   const [idx, setIdx] = React.useState(0);
// //   const [src, setSrc] = React.useState(sources[0] || placeholder);
// //   const [loaded, setLoaded] = React.useState(false);

// //   React.useEffect(() => setLoaded(false), [idx]);

// //   React.useEffect(() => {
// //     if (!sources.length) return;
// //     let alive = true;
// //     const candidate = sources[idx] || sources[sources.length - 1];
// //     const img = new Image();
// //     img.src = candidate;
// //     img.onload = () => {
// //       if (alive) {
// //         setSrc(candidate);
// //         setLoaded(true);
// //       }
// //     };
// //     img.onerror = () => {
// //       if (!alive) return;
// //       if (idx < sources.length - 1) setIdx((n) => n + 1);
// //       else {
// //         setSrc(placeholder);
// //         setLoaded(true);
// //       }
// //     };
// //     return () => {
// //       alive = false;
// //     };
// //   }, [idx, sources, placeholder]);

// //   const fitClass =
// //     fit === "cover"
// //       ? "object-cover"
// //       : fit === "fill"
// //       ? "object-fill"
// //       : "object-contain";

// //   return (
// //     <div
// //       role="img"
// //       aria-label={alt}
// //       className={`relative ${className} ${aspect} ${rounded} overflow-hidden bg-gray-100`}
// //     >
// //       {!loaded && (
// //         <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-gray-200 to-gray-100" />
// //       )}
// //       <img
// //         src={placeholder}
// //         alt=""
// //         aria-hidden="true"
// //         className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
// //           loaded ? "opacity-0" : "opacity-100"
// //         }`}
// //         draggable="false"
// //       />
// //       <img
// //         src={src}
// //         alt=""
// //         className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
// //           loaded ? "opacity-100" : "opacity-0"
// //         }`}
// //         loading="eager"
// //         referrerPolicy="no-referrer"
// //         onLoad={() => setLoaded(true)}
// //         onError={() => setLoaded(true)}
// //         draggable="false"
// //       />
// //     </div>
// //   );
// // }

// function ImageChain({
//   sources = ["/placeholder.png"],
//   alt = "",
//   className = "",
//   fit = "cover",
//   aspect = "aspect-square",
//   placeholder = "/placeholder.png", // <- your logo/placeholder
//   rounded = "rounded-xl",
// }) {
//   const [idx, setIdx] = React.useState(0);
//   const [src, setSrc] = React.useState(sources[0] || placeholder);
//   const [loaded, setLoaded] = React.useState(false);

//   React.useEffect(() => setLoaded(false), [idx]);

//   React.useEffect(() => {
//     if (!sources.length) return;
//     let alive = true;
//     const candidate = sources[idx] || sources[sources.length - 1];
//     const img = new Image();
//     img.src = candidate;
//     img.onload = () => {
//       if (alive) {
//         setSrc(candidate);
//         setLoaded(true);
//       }
//     };
//     img.onerror = () => {
//       if (!alive) return;
//       if (idx < sources.length - 1) setIdx((n) => n + 1);
//       else {
//         setSrc(placeholder);
//         setLoaded(true);
//       }
//     };
//     return () => {
//       alive = false;
//     };
//   }, [idx, sources, placeholder]);

//   const fitClass =
//     fit === "cover"
//       ? "object-cover"
//       : fit === "fill"
//       ? "object-fill"
//       : "object-contain";

//   return (
//     <div
//       role="img"
//       aria-label={alt}
//       className={`relative ${className} ${aspect} ${rounded} overflow-hidden bg-gray-100`}
//     >
//       {/* Placeholder image (visible until actual loads) */}
//       <img
//         src={placeholder}
//         alt=""
//         aria-hidden="true"
//         className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
//           loaded ? "opacity-0" : "opacity-100"
//         }`}
//         draggable="false"
//       />

//       {/* Actual image */}
//       <img
//         src={src}
//         alt={alt}
//         className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
//           loaded ? "opacity-100" : "opacity-0"
//         }`}
//         loading="lazy"
//         referrerPolicy="no-referrer"
//         onLoad={() => setLoaded(true)}
//         onError={() => setLoaded(true)}
//         draggable="false"
//       />
//     </div>
//   );
// }

// /* -------------------------------- Page -------------------------------- */

// export default function CoursesToPromote() {
//   const [items, setItems] = useState([]); // courses + products (approved)
//   const [userReferralCode, setUserReferralCode] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [copiedId, setCopiedId] = useState("");
//   const [activeTab, setActiveTab] = useState("courses"); // 'courses' | 'products'

//   const auth = getAuth();
//   const user = auth.currentUser;

//   // Get this user's referral code (users → fallback referral_users)
//   useEffect(() => {
//     if (!user) return;
//     (async () => {
//       try {
//         const userSnap = await getDoc(doc(db, "users", user.uid));
//         let code =
//           (userSnap.exists() && (userSnap.data().referralCode || "")) || "";

//         if (!code) {
//           const qs = await getDocs(
//             query(
//               collection(db, "referral_users"),
//               where("uid", "==", user.uid),
//               qLimit(1)
//             )
//           );
//           if (!qs.empty) code = qs.docs[0].data().referralCode || "";
//         }

//         setUserReferralCode(code || user.uid);
//       } catch {
//         setUserReferralCode(user?.uid || "");
//       }
//     })();
//   }, [user]);

//   // Load approved items (courses + products live in the same "courses" collection with type)
//   useEffect(() => {
//     (async () => {
//       setLoading(true);
//       try {
//         const qApproved = query(
//           collection(db, "courses"),
//           where("status", "==", "approved")
//         );
//         const snap = await getDocs(qApproved);
//         const arr = [];
//         snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
//         setItems(arr);
//         console.log("arr", arr);
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, []);

//   // Split by type with robust fallback (default to 'course' if missing)
//   const onlyCourses = useMemo(
//     () =>
//       items.filter((it) => (it.type || "course").toLowerCase() === "course"),
//     [items]
//   );
//   const onlyProducts = useMemo(
//     () => items.filter((it) => (it.type || "").toLowerCase() === "product"),
//     [items]
//   );

//   // Build public link per item type + referral code
//   function buildPublicLink(it) {
//     const isProduct = (it.type || "").toLowerCase() === "product";
//     // Product page can use a public/computed ID or slug if present; fallback to doc id
//     const productId =
//       it.publicId || it.slug || it.routeId || it.slugId || it.id;
//     const base = isProduct
//       ? `https://txtrademart.online/product/${encodeURIComponent(productId)}`
//       : `https://txtrademart.online/course/${encodeURIComponent(it.id)}`;
//     return `${base}?ref=${encodeURIComponent(userReferralCode)}`;
//   }

//   const handleCopy = (link, id) => {
//     navigator.clipboard.writeText(link);
//     setCopiedId(id);
//     setTimeout(() => setCopiedId(""), 1500);
//   };

//   const itemsForTab = activeTab === "courses" ? onlyCourses : onlyProducts;

//   if (!user)
//     return (
//       <div className="max-w-5xl mx-auto py-8 px-4">
//         <h1 className="text-2xl font-bold mb-4">
//           Courses & Products to Promote
//         </h1>
//         <div className="text-gray-600">
//           Please log in to view your referral links.
//         </div>
//       </div>
//     );

//   return (
//     <div className="max-w-5xl mx-auto py-8 px-4">
//       <h1 className="text-2xl font-bold mb-2">Promote & Earn</h1>
//       <div className="mb-6 text-gray-600">
//         Share these approved listings with your audience using your unique
//         referral link. When someone buys, you’ll earn commission!
//       </div>

//       {/* Tabs */}
//       <div className="mb-6">
//         <div className="inline-flex rounded-2xl bg-gray-100 p-1">
//           <button
//             className={`px-4 py-2 rounded-2xl text-sm font-semibold transition ${
//               activeTab === "courses"
//                 ? "bg-white shadow text-blue-700"
//                 : "text-gray-600 hover:text-gray-800"
//             }`}
//             onClick={() => setActiveTab("courses")}
//           >
//             Courses{" "}
//             <span className="text-gray-400">({onlyCourses.length})</span>
//           </button>
//           <button
//             className={`ml-1 px-4 py-2 rounded-2xl text-sm font-semibold transition ${
//               activeTab === "products"
//                 ? "bg-white shadow text-blue-700"
//                 : "text-gray-600 hover:text-gray-800"
//             }`}
//             onClick={() => setActiveTab("products")}
//           >
//             Products{" "}
//             <span className="text-gray-400">({onlyProducts.length})</span>
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div>Loading...</div>
//       ) : itemsForTab.length === 0 ? (
//         <div className="text-gray-500">
//           {activeTab === "courses"
//             ? "No approved courses available yet."
//             : "No approved products available yet."}
//         </div>
//       ) : (
//         // equal-height cards per row
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-fr">
//           {itemsForTab.map((item) => {
//             const covers = buildCoverCandidates(item);
//             const refLink = buildPublicLink(item);
//             return (
//               <div
//                 key={item.id}
//                 className="h-full bg-white rounded-2xl shadow p-6 flex flex-col gap-3 border border-transparent hover:border-blue-300 transition"
//               >
//                 {/* Top: image + meta */}
//                 <div className="flex gap-4 items-center">
//                   <ImageChain
//                     sources={covers}
//                     alt={item.title}
//                     className="w-20"
//                     aspect="aspect-square"
//                     fit="cover"
//                     placeholder="/your-logo.png"
//                     rounded="rounded-xl"
//                   />
//                   <div className="min-w-0">
//                     <div className="font-bold text-lg line-clamp-2">
//                       {item.title}
//                     </div>
//                     <div className="text-gray-500 text-xs mb-1 truncate">
//                       {(item.type || "course").toUpperCase()} • Category:{" "}
//                       {item.category || "N/A"}
//                     </div>
//                     <div className="font-bold text-blue-700 text-xl">
//                       LKR{" "}
//                       {item.finalPrice?.toLocaleString?.() ??
//                         Number(item.price || 0).toLocaleString("en-LK")}
//                     </div>
//                     <div className="text-green-600 text-xs">
//                       Potential commission:{" "}
//                       <b>
//                         {item.commission !== undefined &&
//                         item.commission !== null
//                           ? `LKR ${Number(item.commission || 0).toLocaleString(
//                               "en-LK"
//                             )}`
//                           : "—"}
//                       </b>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Spacer pushes actions to bottom */}
//                 <div className="grow" />

//                 {/* Bottom: link + actions */}
//                 <div className="flex flex-col gap-2 mt-2">
//                   <input
//                     type="text"
//                     className="p-2 border rounded w-full text-xs text-gray-600 bg-gray-50"
//                     value={refLink}
//                     readOnly
//                     onFocus={(e) => e.target.select()}
//                   />
//                   <div className="flex items-center gap-2">
//                     <button
//                       className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 font-bold"
//                       onClick={() => handleCopy(refLink, item.id)}
//                     >
//                       Copy Referral Link
//                     </button>
//                     <a
//                       href={refLink}
//                       target="_blank"
//                       rel="noreferrer"
//                       className="text-blue-600 text-sm font-semibold hover:underline"
//                     >
//                       Open page
//                     </a>
//                   </div>
//                   {copiedId === item.id && (
//                     <span className="text-green-600 text-xs font-semibold">
//                       Copied!
//                     </span>
//                   )}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// }

// src/pages/CoursesToPromote.jsx
import React, { useEffect, useMemo, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  limit as qLimit,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { readAffiliateCommissionByLevel } from "../utils/affiliateCommission";

/* ----------------------------- Helpers ----------------------------- */
function pickUrl(v) {
  if (!v) return "";
  if (typeof v === "string") return v.trim();
  if (Array.isArray(v)) return pickUrl(v[0]);
  if (typeof v === "object") {
    return pickUrl(
      v.url || v.src || v.href || v.downloadURL || v.path || v.link,
    );
  }
  return "";
}

function extractDriveId(rawUrl) {
  const url = pickUrl(rawUrl);
  if (!url) return null;
  try {
    const u = new URL(url);
    if (!u.hostname.includes("drive.google.com")) return null;
    const m = url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (m && m[1]) return m[1];
    const q = u.searchParams.get("id");
    if (q) return q;
  } catch (_) {}
  return null;
}
function buildDriveImageCandidates(thumbnailUrl) {
  const url = pickUrl(thumbnailUrl);
  if (!url) return ["/placeholder.gif"];

  const id = extractDriveId(url);
  if (!id) return [url];

  return [
    `https://drive.usercontent.google.com/uc?id=${id}&export=view`,
    `https://drive.google.com/uc?export=view&id=${id}`,
    `https://drive.google.com/uc?export=download&id=${id}`,
    `https://lh3.googleusercontent.com/d/${id}=w1600-h900-no`,
    `https://drive.google.com/thumbnail?id=${id}&sz=w1600`,
  ];
}
function buildCoverCandidates(item = {}) {
  const urls = [
    item?.thumbnailUrl,
    item?.thumbnail,
    Array.isArray(item?.images) ? item.images[0] : "",
    Array.isArray(item?.productImages) ? item.productImages[0] : "",
    Array.isArray(item?.serviceImages) ? item.serviceImages[0] : "",
    Array.isArray(item?.courseImages) ? item.courseImages[0] : "",
    item?.image,
    item?.cover,
  ]
    .map(pickUrl)
    .filter(Boolean);

  if (!urls.length) return ["/placeholder.gif"];

  const chain = [];
  urls.forEach((url) => {
    buildDriveImageCandidates(url).forEach((candidate) => {
      if (candidate && !chain.includes(candidate)) {
        chain.push(candidate);
      }
    });
  });

  if (!chain.includes("/placeholder.gif")) {
    chain.push("/placeholder.gif");
  }
  return chain;
}

function isAffiliateListingVisible(item = {}) {
  if (String(item?.status || "").toLowerCase() !== "approved") return false;
  if (item?.affiliateEnabled !== true) return false;
  if (
    String(item?.type || "").toLowerCase() === "product" &&
    item?.isActive === false
  ) {
    return false;
  }
  return true;
}

function ImageChain({
  sources = ["/placeholder.gif"],
  alt = "",
  className = "",
  fit = "cover",
  aspect = "aspect-square",
  placeholder = "/placeholder.gif",
  rounded = "rounded-xl",
}) {
  const [idx, setIdx] = React.useState(0);
  const [src, setSrc] = React.useState(sources[0] || placeholder);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => setLoaded(false), [idx]);

  React.useEffect(() => {
    if (!sources.length) return;
    let alive = true;
    const candidate = sources[idx] || sources[sources.length - 1];
    const img = new Image();
    img.src = candidate;
    img.onload = () => {
      if (alive) {
        setSrc(candidate);
        setLoaded(true);
      }
    };
    img.onerror = () => {
      if (!alive) return;
      if (idx < sources.length - 1) setIdx((n) => n + 1);
      else {
        setSrc(placeholder);
        setLoaded(true);
      }
    };
    return () => {
      alive = false;
    };
  }, [idx, sources, placeholder]);

  const fitClass =
    fit === "cover"
      ? "object-cover"
      : fit === "fill"
      ? "object-fill"
      : "object-contain";

  return (
    <div
      role="img"
      aria-label={alt}
      className={`relative ${className} ${aspect} ${rounded} overflow-hidden bg-gray-100`}
    >
      <img
        src={placeholder}
        alt=""
        aria-hidden="true"
        className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
          loaded ? "opacity-0" : "opacity-100"
        }`}
        draggable="false"
      />
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 h-full w-full ${fitClass} transition-opacity duration-300 ${
          loaded ? "opacity-100" : "opacity-0"
        }`}
        loading="lazy"
        referrerPolicy="no-referrer"
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        draggable="false"
      />
    </div>
  );
}

/* -------------------------------- Page -------------------------------- */
export default function CoursesToPromote() {
  const [items, setItems] = useState([]); // courses + products + services
  const [userReferralCode, setUserReferralCode] = useState("");
  const [referralStatus, setReferralStatus] = useState("");
  const [referralLevel, setReferralLevel] = useState(1);
  const [loading, setLoading] = useState(true);
  const [copiedId, setCopiedId] = useState("");
  const [inviteCopied, setInviteCopied] = useState("");
  const [activeTab, setActiveTab] = useState("courses"); // 'courses' | 'products' | 'services'

  const auth = getAuth();
  const user = auth.currentUser;

  // User referral code
  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const referralSnap = await getDoc(doc(db, "referral_users", user.uid));
        let code = "";

        if (referralSnap.exists()) {
          const data = referralSnap.data();
          code = data.referralCode || "";
          setReferralStatus(data.status || "");
          setReferralLevel(Number(data.level || 1) || 1);
        }

        if (!code) {
          const userSnap = await getDoc(doc(db, "users", user.uid));
          code =
            (userSnap.exists() && (userSnap.data().referralCode || "")) || "";
        }

        if (!code) {
          const qs = await getDocs(
            query(
              collection(db, "referral_users"),
              where("uid", "==", user.uid),
              qLimit(1)
            )
          );
          if (!qs.empty) {
            const data = qs.docs[0].data();
            code = data.referralCode || "";
            setReferralStatus((prev) => prev || data.status || "");
            setReferralLevel((prev) => prev || Number(data.level || 1) || 1);
          }
        }
        setUserReferralCode(code || user.uid);
      } catch {
        setUserReferralCode(user?.uid || "");
      }
    })();
  }, [user]);

  // Load approved items
  useEffect(() => {
    setLoading(true);
    const unsub = onSnapshot(
      query(collection(db, "courses"), where("status", "==", "approved")),
      (snap) => {
        const arr = [];
        snap.forEach((d) => {
          const data = d.data() || {};
          const type = String(
            data?.type ||
              (data?.productImages || data?.productMainDesc
                ? "product"
                : "course"),
          ).toLowerCase();
          const item = { id: d.id, ...data, type };
          if (isAffiliateListingVisible(item)) {
            arr.push(item);
          }
        });
        setItems(arr);
        setLoading(false);
      },
      () => {
        setItems([]);
        setLoading(false);
      },
    );
    return () => unsub();
  }, []);

  // Split by type (robust)
  const onlyCourses = useMemo(
    () =>
      items.filter((it) => (it.type || "course").toLowerCase() === "course"),
    [items]
  );
  const onlyProducts = useMemo(
    () => items.filter((it) => (it.type || "").toLowerCase() === "product"),
    [items]
  );
  const onlyServices = useMemo(
    () => items.filter((it) => (it.type || "").toLowerCase() === "service"),
    [items]
  );

  // Referral link
  function buildPublicLink(it) {
    const t = (it.type || "course").toLowerCase();
    const idOrSlug = it.publicId || it.slug || it.routeId || it.slugId || it.id;
    const publicBaseUrl = "https://www.ceylonwebmall.com";
    const base =
      t === "product"
        ? `${publicBaseUrl}/product/${encodeURIComponent(idOrSlug)}`
        : t === "service"
        ? `${publicBaseUrl}/services/${encodeURIComponent(it.id)}`
        : `${publicBaseUrl}/course/${encodeURIComponent(it.id)}`;
    return `${base}?ref=${encodeURIComponent(userReferralCode)}`;
  }

  function commissionForUser(it) {
    const byLevel = readAffiliateCommissionByLevel(it);
    const levelKey = Math.min(3, Math.max(1, Number(referralLevel || 1) || 1));
    return Math.max(0, Number(byLevel[levelKey] || 0) || 0);
  }

  const canInviteInstructors =
    !!userReferralCode && referralStatus === "approved" && referralLevel < 3;
  const instructorReferralLink = `https://myshop.ceylonwebmall.com/register?ref=${encodeURIComponent(
    userReferralCode
  )}`;
  const salesAgentReferralLink = `https://partners.ceylonwebmall.com/register?ref=${encodeURIComponent(
    userReferralCode
  )}`;

  const handleCopy = (link, id) => {
    navigator.clipboard.writeText(link);
    setCopiedId(id);
    setTimeout(() => setCopiedId(""), 1500);
  };

  const handleInviteCopy = (kind, link) => {
    navigator.clipboard.writeText(link);
    setInviteCopied(kind);
    setTimeout(() => setInviteCopied(""), 1500);
  };

  const handleShare = async (title, text, url) => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url });
        return;
      }
      await navigator.clipboard.writeText(url);
      setInviteCopied("shared");
      setTimeout(() => setInviteCopied(""), 1500);
    } catch {
      // ignore
    }
  };

  const tabItems =
    activeTab === "courses"
      ? onlyCourses
      : activeTab === "products"
      ? onlyProducts
      : onlyServices;

  if (!user)
    return (
      <div className="max-w-5xl mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">Promote & Earn</h1>
        <div className="text-gray-600">
          Please log in to view your referral links.
        </div>
      </div>
    );

  return (
    <div className="max-w-5xl mx-auto py-8 px-4">
      <h1 className="text-2xl font-bold mb-2">Promote & Earn</h1>
      <div className="mb-6 text-gray-600">
        Share these affiliate-enabled listings with your audience using your
        unique referral link. When someone buys, you’ll earn the fixed
        commission shown on each card.
      </div>

      <div className="mb-6 grid gap-4 md:grid-cols-2">
        <div className="rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50 to-white p-5 shadow-sm">
          <div className="text-sm font-semibold uppercase tracking-wide text-blue-600">
            Invite Shop Owners
          </div>
          <h2 className="mt-1 text-xl font-bold text-gray-900">
            Instructor / Store Signup Link
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Share this link when you want someone to create a shop through your
            referral. Their monthly package commission comes through this
            instructor invite flow.
          </p>

          {canInviteInstructors ? (
            <>
              <input
                type="text"
                className="mt-4 w-full rounded-2xl border border-blue-100 bg-white px-3 py-3 text-sm text-gray-700"
                value={instructorReferralLink}
                readOnly
                onFocus={(e) => e.target.select()}
              />
              <div className="mt-3 flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  className="rounded-xl bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
                  onClick={() =>
                    handleInviteCopy("instructor", instructorReferralLink)
                  }
                >
                  {inviteCopied === "instructor" ? "Copied!" : "Copy Link"}
                </button>
                <button
                  type="button"
                  className="rounded-xl border border-blue-200 px-4 py-2 font-semibold text-blue-700 hover:bg-blue-50"
                  onClick={() =>
                    handleShare(
                      "Become a Ceylon Web Mall Instructor",
                      "Create your shop with my referral link:",
                      instructorReferralLink
                    )
                  }
                >
                  Share
                </button>
                <a
                  href={instructorReferralLink}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-blue-700 hover:underline"
                >
                  Open link
                </a>
              </div>
            </>
          ) : referralLevel >= 3 ? (
            <div className="mt-4 rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-800">
              Level 3 accounts cannot invite new instructors.
            </div>
          ) : (
            <div className="mt-4 rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-800">
              Your KYC needs admin approval before this invite link becomes
              active.
            </div>
          )}
        </div>

        <div className="rounded-3xl border border-fuchsia-100 bg-gradient-to-br from-fuchsia-50 to-white p-5 shadow-sm">
          <div className="text-sm font-semibold uppercase tracking-wide text-fuchsia-600">
            Invite Sales Agents
          </div>
          <h2 className="mt-1 text-xl font-bold text-gray-900">
            Referral Signup Link
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            This is your standard sales-agent invite link for building your
            downline.
          </p>
          <input
            type="text"
            className="mt-4 w-full rounded-2xl border border-fuchsia-100 bg-white px-3 py-3 text-sm text-gray-700"
            value={salesAgentReferralLink}
            readOnly
            onFocus={(e) => e.target.select()}
          />
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <button
              type="button"
              className="rounded-xl bg-fuchsia-600 px-4 py-2 font-semibold text-white hover:bg-fuchsia-700"
              onClick={() => handleInviteCopy("agent", salesAgentReferralLink)}
            >
              {inviteCopied === "agent" ? "Copied!" : "Copy Link"}
            </button>
            <button
              type="button"
              className="rounded-xl border border-fuchsia-200 px-4 py-2 font-semibold text-fuchsia-700 hover:bg-fuchsia-50"
              onClick={() =>
                handleShare(
                  "Join Ceylon Web Mall",
                  "Sign up with my sales-agent link:",
                  salesAgentReferralLink
                )
              }
            >
              Share
            </button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="mb-6">
        <div className="inline-flex rounded-2xl bg-gray-100 p-1">
          {[
            { key: "courses", label: "Courses", count: onlyCourses.length },
            { key: "products", label: "Products", count: onlyProducts.length },
            { key: "services", label: "Services", count: onlyServices.length },
          ].map((t) => (
            <button
              key={t.key}
              className={`px-4 py-2 rounded-2xl text-sm font-semibold transition ${
                activeTab === t.key
                  ? "bg-white shadow text-blue-700"
                  : "text-gray-600 hover:text-gray-800"
              }`}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label} <span className="text-gray-400">({t.count})</span>
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <div>Loading...</div>
      ) : tabItems.length === 0 ? (
        <div className="text-gray-500">
          No affiliate-enabled {activeTab} available yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 auto-rows-fr">
          {tabItems.map((item) => {
            const covers = buildCoverCandidates(item);
            const refLink = buildPublicLink(item);
            const myCommission = commissionForUser(item);
            const price = item.price ?? item.finalPrice ?? item.basePrice ?? 0;

            return (
              <div
                key={item.id}
                className="h-full bg-white rounded-2xl shadow p-6 flex flex-col gap-3 border border-transparent hover:border-blue-300 transition"
              >
                {/* Top: image + meta */}
                <div className="flex gap-4 items-center">
                  <ImageChain
                    sources={covers}
                    alt={item.title}
                    className="w-20"
                    aspect="aspect-square"
                    fit="cover"
                    placeholder="/placeholder.png"
                    rounded="rounded-xl"
                  />
                  <div className="min-w-0">
                    <div className="font-bold text-lg line-clamp-2">
                      {item.title}
                    </div>
                    <div className="text-gray-500 text-xs mb-1 truncate">
                      {(item.type || "course").toUpperCase()} • Category:{" "}
                      {item.category || "N/A"}
                    </div>
                    <div className="font-bold text-blue-700 text-xl">
                      LKR {Number(price || 0).toLocaleString("en-LK")}
                    </div>
                    <div className="text-green-600 text-sm mt-1">
                      Your commission:{" "}
                      <b>
                        LKR {Number(myCommission || 0).toLocaleString("en-LK")}
                      </b>
                    </div>
                    <div className="mt-2 inline-flex w-fit items-center rounded-full bg-fuchsia-50 px-2.5 py-1 text-xs font-semibold text-fuchsia-700">
                      Affiliate enabled
                    </div>
                  </div>
                </div>

                <div className="grow" />

                {/* Bottom: link + actions */}
                <div className="flex flex-col gap-2 mt-2">
                  <input
                    type="text"
                    className="p-2 border rounded w-full text-xs text-gray-600 bg-gray-50"
                    value={refLink}
                    readOnly
                    onFocus={(e) => e.target.select()}
                  />
                  <div className="flex items-center gap-2">
                    <button
                      className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 font-bold"
                      onClick={() => handleCopy(refLink, item.id)}
                    >
                      Copy Referral Link
                    </button>
                    <a
                      href={refLink}
                      target="_blank"
                      rel="noreferrer"
                      className="text-blue-600 text-sm font-semibold hover:underline"
                    >
                      Open page
                    </a>
                  </div>
                  {copiedId === item.id && (
                    <span className="text-green-600 text-xs font-semibold">
                      Copied!
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
